import React, { useState, useEffect, useCallback} from 'react';
import { Grid, MenuItem, Select, FormControl, InputLabel } from '@material-ui/core';
import TableCollapsible from '../../Tables/TableColapseNoPaginationAlteracao';
import DatePicker from '@src/components/Shared/DatePicker';
import { subDays, addDays } from 'date-fns';
import { useSnackbar } from 'notistack';
import Service from './services';
import ComponentPerfilServices from './services';
import { Select as SelectAntd, Spin, Form} from 'antd';
import Button from '@components/Shared/Buttons/Button';
import DeleteForeverTwoToneIcon from '@mui/icons-material/DeleteForeverTwoTone';

import ButtonComponent from '@components/Shared/Buttons/Button';


import { TuneOutlined, SearchOutlined } from '@material-ui/icons';
import InvisibleContent from '../../InvisibleContent';


interface IControleAlteracao {
  Data: string;
  Tipo_Informacao: string;
  Usuario: string;
  Campo: [
    {
      Coluna: string;
      Valor: string;
    },
  ];
}

interface IProps {
  idPerfil: number;
}

interface IFiltro {
  id: number;
  descricao: string;
}

const columnsLabel = {
  Data: 'Data',
  Tipo_Informacao: 'Alteração',
  Usuario: 'Usuário',
  Campo: [
    {
      Coluna: '',
      Valor: '',
    },
  ],
};

const GetAlteracao: React.FC<IProps> = ({ idPerfil }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<IControleAlteracao[]>([]);
  const [selectedFilter, setSelectedFilter] = useState('');
  const [periodo, setPeriodo] = useState<any>([addDays(new Date(), -45507), new Date()]);
  const [periodoFiltro, setPeriodoFiltro] = useState<any>([addDays(new Date(), -45507), new Date()]);
  const [formRef] = Form.useForm();


  const { enqueueSnackbar } = useSnackbar();
  const [tipoInformacao, setTipoInformacao] = useState<number>(0);
  const [tipoInformacaoFiltro, setTipoInformacaoFiltro] = useState<number>(0);


  const [openFiltro, setOpenFiltro] = useState(false);

  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItens, setTotalItems] = useState(0);
  const [page, setPage] = useState(1);

  const [filtro, setFiltro] = useState<IFiltro[]>([
    { id: 1, descricao: 'Tipo perfil' },
    { id: 21, descricao: 'Tipo correspondência' },
    { id: 22, descricao: 'Forma de contribuição' },
    { id: 19, descricao: 'Valor padrão' },
    { id: 7, descricao: 'Convênio - Débito automático' },
    { id: 2, descricao: 'Dígito conta - Débito automático' },
    { id: 3, descricao: 'Número conta - Débito automático' },
    { id: 4, descricao: 'Dígito agência - Débito automático' },
    { id: 5, descricao: 'Número agência - Débito automático' },
    { id: 6, descricao: 'Dia vencimento - Débito automático' },
    { id: 23, descricao: 'Valor - Débito automático' },
    { id: 20, descricao: 'Recorrência - Débito automático' },
    { id: 24, descricao: 'Código - Débito automático' },
    { id: 8, descricao: 'E-mail' },
    { id: 12, descricao: 'Celular' },
    { id: 10, descricao: 'WhatsApp' },
    { id: 11, descricao: 'Telefone fixo' },
    { id: 9, descricao: 'Telefone comercial' },
    { id: 18, descricao: 'CEP' },
    { id: 15, descricao: 'Estado' },
    { id: 16, descricao: 'Cidade' },
    { id: 17, descricao: 'Endereço' },
    { id: 13, descricao: 'Bairro' },
    { id: 14, descricao: 'Complemento' },
    { id: 0, descricao: '' },
  ]);


  const setValuesOrErrorControleAltercao = (error: boolean, response: any) => {
    if (!error && response) {
      setTotalItems(response.total_itens);
      setTotalPages(response.total_pagina);
      setData(response.controleAlteracao);
      setLoading(false);
    } else {
      enqueueSnackbar('Ocorreu um erro.', {
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
      setLoading(false);
    }
  };

  const setValuesOrErrorControleAlteracaoFiltro = (error: boolean, response: any) => {
    if (!error && response) {
      setTotalItems(response.total_itens);
      setTotalPages(response.total_pagina);
      setData(response.controleAlteracaoFiltro);
      setLoading(false);
    } else {
      enqueueSnackbar('Ocorreu um erro.', {
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
      setLoading(false);
    }
  };

  function setPagination(page: number, itemsPage: number) {
    if (itemsPerPage !== itemsPage) {
      page = 1;
    }
    setItemsPerPage(itemsPage);

  }

  const firstLoad = async (page: number, itemsPage: number) => {
    setLoading(true);

    const service = new ComponentPerfilServices();

    const { error, response } = await service.buscaPerfilControleAlteracaoFiltro({
      perfil_id: idPerfil,
      tipo_informacao: tipoInformacao,
      data_inicial: periodo[0],
      data_final: periodo[1],
      page_number: page,
      page_size: itemsPage,
    });
    setLoading(false);
    setValuesOrErrorControleAlteracaoFiltro(error, response);
  };

  const onChangeControleAlteracaoFiltro = async (page: number, itemsPage: number) => {
    setLoading(true);

    const service = new ComponentPerfilServices();

    const { error, response } = await service.buscaPerfilControleAlteracaoFiltro({
      perfil_id: idPerfil,
      tipo_informacao: tipoInformacaoFiltro,
      data_inicial: periodoFiltro[0],
      data_final: periodoFiltro[1],
      page_number: page,
      page_size: itemsPage,
    });
    setLoading(false);
    setValuesOrErrorControleAlteracaoFiltro(error, response);
  };

  const onChangeDates = async (dates: any) => {
    setPeriodoFiltro(dates);
  };


  useEffect(() => {
    firstLoad(page, itemsPerPage);
    console.log('PRIMEIRO TESTE')
  }, []);

  const clearData = () => {
    formRef.setFieldsValue({
      data
    });
    //console.log('TESTAJDKASDL')

      //setTipoInformacao(0)
  };

  const clearTipoInfo = () => {
    formRef.setFieldsValue({
      tipoInformacao,
    });

      //setTipoInformacao(0)
  };

  const handleOpen = () => {
    setOpenFiltro(true);
  };


  return (
    <>
      <Grid container style={{paddingBottom: 10}}>
        <InvisibleContent visible= {openFiltro === false}>
          <Grid item  sm={2} xs={2} style={{paddingTop: 7}}>
            <Button
              color="secondary"
              fullWidth
              style={{
                height: 46,
              }}
              onClick={handleOpen}
            >
              <TuneOutlined style={{ marginRight: 10 }} /> Filtros
            </Button>
          </Grid>
        </InvisibleContent>

        <InvisibleContent visible= {openFiltro === true}>

          <Form
            //size="middle"
            layout="vertical"
            scrollToFirstError={true}
            // onFinish={createEstrategia}
            //onError={() => HandleChangeEtapa(0)
            //requiredMark={false}
            style={{ width: '100%' }}
            form={formRef}
            initialValues={{

            }}
          >

            <Grid container style={{paddingBottom: 10}} >

              <Grid item lg={4} xs={4} sm={4}>
                <Form.Item
                  name="data"
                >
                  <DatePicker
                    cleanable={false}
                    notUseDefaultValue={true}
                    title=" "
                    color={'default'}
                    setValor={onChangeDates}
                    placement={'bottomEnd'}
                  />
                </Form.Item>
              </Grid>

              <Grid item xs={4} sm={4} style={{paddingTop: 10, paddingLeft: 5}}>
                <Form.Item
                  name="tipoInformacao"
                >
                  <SelectAntd
                    placeholder={'Tipo de informação'}
                    onChange={(id: number) => {
                      setTipoInformacaoFiltro(id);
                    }}
                  >
                    {filtro.map(filtro => (
                      <SelectAntd.Option key={filtro.id} value={filtro.id}>
                        {filtro.descricao}
                      </SelectAntd.Option>
                    ))}
                  </SelectAntd>
                </Form.Item>
              </Grid>

              <Grid item sm={2} xs={2} style={{paddingTop: 7}}>
                <Form.Item
                  name="button1"
                >
                  <Button
                    color="secondary"
                    fullWidth
                    onClick={() => {
                      onChangeControleAlteracaoFiltro(page, itemsPerPage);
                    }}
                  >
                  <SearchOutlined style={{ marginRight: 10 }} /> Buscar
                </Button>
                </Form.Item>
              </Grid>

              <Grid item  sm={2} xs={2} style={{paddingTop: 7}}>
                <Form.Item
                  name="button2"
                >
                  <Button
                    color="primary"
                    fullWidth
                    onClick={() => {
                      firstLoad(page, itemsPerPage);
                      clearData();
                      clearTipoInfo();
                      setOpenFiltro(false);
                    }}
                  >
                    <DeleteForeverTwoToneIcon style={{ marginLeft: 10 }} /> Limpar
                  </Button>
                </Form.Item>
              </Grid>
            </Grid>
          </Form>
          </InvisibleContent>
        </Grid>

      <TableCollapsible
        loading={loading}
        columns={[columnsLabel]}
        FieldsBold={['Tipo_Informacao']}
        data={data}
        keys={['Data', 'Tipo_Informacao', 'Usuario', 'Detalhes']}
             />
    </>
  );
};

export default GetAlteracao;
